import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { Footer } from './Footer';
import { Header } from './Header';
import { Sidebar, SIDEBAR_WIDTH } from './Sidebar';

const defaultRender = () => null;

type PageProps = {
  render: () => React.ReactElement | null;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  noPaper?: boolean;
};

export const Page = ({ render = defaultRender, maxWidth = 'sm', noPaper = false }: PageProps) => {
  return (
    <Box sx={{ display: 'flex' }}>
      <Sidebar />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: `calc(100% - ${SIDEBAR_WIDTH}px - ${SIDEBAR_WIDTH / 4}px)`,
          ml: `${SIDEBAR_WIDTH / 4}px`,
          minHeight: '100vh',
          backgroundColor: (theme) =>
            theme.palette.mode === 'dark'
              ? theme.palette.background.default
              : '#f5f5f5',
        }}
      >
        <Header />
        <Box sx={{ pt: 8 }}>
          <Container maxWidth={maxWidth} sx={{ mb: 4, px: { xs: 2, md: 2 } }}>
            {noPaper ? (
              <Box sx={{ my: { xs: 2, md: 3 }, p: { xs: 2, md: 3 } }}>
                {render()}
              </Box>
            ) : (
              <Paper
                variant="outlined"
                sx={{ my: { xs: 2, md: 3 }, p: { xs: 2, md: 3 } }}
              >
                {render()}
              </Paper>
            )}
            <Footer />
          </Container>
        </Box>
      </Box>
    </Box>
  );
};
